module.exports = __webpack_public_path__ + "img/i-sec01-img03.4c397746.png";